(() => {
  if (customElements.get('store-suggestions')) return;
  class StoreSuggestions extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialised) return;
      this.dataset.initialised = 'true';
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.load();
          }
        }, { rootMargin: '0px 0px 400px 0px' });
        this.observer.observe(this);
      } else this.load();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
    async load() {
      this.controller = new AbortController();
      for (const source of [this.dataset.url, this.dataset.fallbackUrl]) {
        if (!source) continue;
        try {
          const url = new URL(source, window.location.origin);
          if (url.origin !== window.location.origin) return;
          const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, { credentials: 'same-origin', signal: this.controller.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) continue;
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = [...parsed.querySelectorAll('store-suggestions')].find(element => element.dataset.sectionId === this.dataset.sectionId);
          const content = incoming?.querySelector('[data-suggestions-content]');
          if (!content?.querySelector('[data-suggestion-id]')) continue;
          const current = this.querySelector('[data-suggestions-content]');
          if (current && this.isConnected) current.replaceWith(content);
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
      }
    }
  }
  customElements.define('store-suggestions', StoreSuggestions);
})();
